import { createTemplate, updateTemplate } from 'common/api/templates';
import showToast from 'common/utils/showToast';

import filterTemplates from '../../templates/actions/filterTemplates';
import * as templatesSelectors from '../../templates/selectors';
import { SAVE, SAVE_SUCCESS, SAVE_FAILURE } from '../actionTypes';
import { createTemplateModalActions } from '../reducer';

import closeModal from './closeModal';

export default (values) => (dispatch, getState) => {
    const filterData = templatesSelectors.getFilterData(getState());

    let newValues = {
        language: values.language,
        title: values.title,
    };
    if (values.type) newValues.type = values.type;
    if (values.system) newValues.system = values.system;

    dispatch(createTemplateModalActions[SAVE]());

    const save = values.id
        ? () => updateTemplate(newValues, values.id)
        : () => createTemplate(newValues);

    save()
        .then((response) => {
            dispatch(createTemplateModalActions[SAVE_SUCCESS](response.data));
            if (filterData) dispatch(filterTemplates(filterData));
            dispatch(closeModal(false));
            showToast();
        })
        .catch((error) =>
            dispatch(
                createTemplateModalActions[SAVE_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
